import { render } from "./DetalleCotizacionComponent.vue?vue&type=template&id=0b16ca5e&scoped=true"
import script from "./DetalleCotizacionComponent.vue?vue&type=script&lang=js"
export * from "./DetalleCotizacionComponent.vue?vue&type=script&lang=js"

import "./DetalleCotizacionComponent.vue?vue&type=style&index=0&id=0b16ca5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b16ca5e"]])

export default __exports__